import {MatrixMultiChoiceScale} from './MatrixMultiChoiceScale';
import {MatrixSingleChoiceScale} from './MatrixSingleChoiceScale';

export class MatrixQuestion {
    constructor(domNode, scales, onChange) {
        this.domNode = domNode;
        this.onChange = onChange;
        this.scales = [];

        this.initScales(scales);
    }

    initScales(scales) {
        this.scales = scales.map(scale => {
            switch (scale.type) {
                case 'SINGLECHOICE' :
                    return new MatrixSingleChoiceScale(this, scale, this.onChange);
                case 'MULTICHOICE' :
                    return new MatrixMultiChoiceScale(this, scale, this.onChange);
            }
        });
    }
}